<style scoped>
    .opt{
margin-top:50px;text-align:center
    }
</style>

<template>
  <div>
    <div>
      <Input v-model="userguid"></Input>
    </div>
    <div class="opt">
      <Button size="large" style="margin-right:20px" @click="cancel">取消</Button>
      <Button size="large" type="primary">确定</Button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["userguid","showModal"],
  data() {
    return {};
  },
  methods: {
      cancel(){
          this.$emit("input", false);
      }
  },
  mounted() {}
};
</script>